import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'selectAllCheck',
  // initialState: booksAdapter.getInitialState(),
  initialState: adapter.getInitialState({
    busy: false,
    selectAllFlag: false,
    shouldRender: true,
  }),
  // initialState: { ids: [], entities: {}, dirty: true },
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
    setSelectAllFlag(state, action) {
      let selectAllFlag = action.payload;
      if (selectAllFlag === false) {
        state.selectAllFlag = false;
      } else {
        state.selectAllFlag = true;
      }
    },
  },
});

const selectAll = (value) => async (dispatch) => {
  try {
    dispatch(slice.actions.setSelectAllFlag(value));
  } catch (err) {
    dispatch(slice.actions.setSelectAllFlag(false));
    utils.displayErrors(err);
  }
};

const actions = {
  ...slice.actions,
  selectAll,
};

const selectors = {
  ...adapter.getSelectors((state) => state.selectAllCheck),
};

export { actions, selectors };

export default slice.reducer;
